'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import GenericNoContentDueToFilteringError from './GenericNoContentDueToFilteringError';

const WizardNoResultsError = () => /*#__PURE__*/_jsx(GenericNoContentDueToFilteringError, {
  headingI18n: "noResultsFound",
  subtitleI18n: "refineResults"
});

export default WizardNoResultsError;